import React from 'react';

// Legacy video submissions store the .mp4 in `image`/`imageRef` with a still
// frame in `thumb`. Everything else (incl. .gif, which <img> animates fine) is
// rendered as an image. Detection keys off imageRef, which has no query string.
const VIDEO_RE = /\.(mp4|mov|m4v|webm)$/i;

export function isVideoSubmission(s) {
    return VIDEO_RE.test(s?.imageRef || "");
}

export function hasPhoto(s) {
    return !!s?.image;
}

export default function SubmissionMedia({ submission: s, height = 200, style }) {
    if (!hasPhoto(s)) {
        return (
            <div style={{
                height,
                minWidth: 120,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f4f4f4",
                color: "#999",
                border: "1px dashed #bbb",
                fontStyle: "italic",
                padding: "0 12px",
                boxSizing: "border-box",
                ...style,
            }}>no photo</div>
        );
    }
    if (isVideoSubmission(s)) {
        return (
            <video
                src={s.image}
                poster={s.thumb || undefined}
                controls
                playsInline
                preload="metadata"
                height={height}
                style={style}
            />
        );
    }
    return (
        <img
            alt=""
            loading="lazy"
            src={s.image}
            height={height}
            style={style}
        />
    );
}
